/**
 * Formats a salary min/max pair for display. When both values are equal, returns a single amount.
 */
export function formatSalaryMinMaxPair(
  min: number,
  max: number,
  formatAmount: (n: number) => string,
  rangeSeparator = ' - ',
): string {
  if (min === max) {
    return formatAmount(min);
  }
  return `${formatAmount(min)}${rangeSeparator}${formatAmount(max)}`;
}

/**
 * Same as formatSalaryMinMaxPair but returns each amount separately instead of one joined
 * string. Lets a caller render every amount with `white-space: nowrap` so a range can only
 * ever break between the two figures, never split a single grouped number across lines.
 */
export function formatSalaryMinMaxParts(
  min: number,
  max: number,
  formatAmount: (n: number) => string,
): string[] {
  if (min === max) {
    return [formatAmount(min)];
  }
  return [formatAmount(min), formatAmount(max)];
}
